import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllNotificationGate(date) {
    try {
        let res = await client.get(`/gate?date_scan=${date}`);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllNotificationGate,
};
